// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-user-carat[data-v-5937b8ab]{align-items:center;border:1px solid #717171;border-radius:4px;display:flex;padding:10px}.p-user-carat__label[data-v-5937b8ab]{color:#1d1d1d;font-size:15px}.p-user-carat__number[data-v-5937b8ab]{color:#1d1d1d;font-size:20px;margin-left:15px}.p-user-carat__number *[data-v-5937b8ab]{background:url(/assets-proxy/images/icon-carat-gray.png) 0 no-repeat;background-size:25px auto;font-size:16px;text-indent:35px}", ""]);
// Exports
module.exports = exports;
